import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { currentUser, roles } = useAuth();
  const location = useLocation();

  // Si pas connecté → redirige vers login
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Si aucune permission spécifique requise → accès autorisé tant que connecté
  if (
    !requiredPermission ||
    (Array.isArray(requiredPermission) && requiredPermission.length === 0)
  ) {
    return children;
  }

  // Vérifie si l'utilisateur a le(s) rôle(s) requis
  const hasPermission = Array.isArray(requiredPermission)
    ? requiredPermission.some((role) => roles.includes(role))
    : roles.includes(requiredPermission);

  if (!hasPermission) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
